<div class="breadcrumb-bar">
     <app-breadcrumb></app-breadcrumb>
</div>
<div class="container">
     <div class="main-container-chart" *ngIf="chartResponseData$ | async as chartResponseData">
          <label class="ch-title">Flight Time by Month</label>
          <div class="container-paging">
               <button class="chevron-btn" (click)="onDecrementYear()" [disabled]="btnDisabledDecrement">
                    <span class="pi pi-angle-left"
                         [style]="{'color': btnDisabledDecrement ? 'var(--p-surface-400)' : 'var(--p-text-color)'}"></span>
               </button>
               <div class="ch-year">{{activeYear}}</div>
               <button pRipple class="chevron-btn" (click)="onIncrementYear()" [disabled]="btnDisabledIncrement">
                    <span class="pi pi-angle-right"
                         [style]="{'color': btnDisabledIncrement ? 'var(--p-surface-400)' : 'var(--p-text-color)'}"></span>
               </button>
          </div>
          <p-tabs 
               [dt]="tabMenu" 
               class="tab-menu" 
               [(value)]="activeIndex" 
               [style]="{ width: '100%'}">
               <p-tablist [style]="{ width: '100%'}">
                    @for (tab of tabItems; track tab.id) {
                    <div [style]="{ 'width': '50%' }">
                         <p-tab [value]="tab.id" [style]="{ 'justify-content': 'center' }">
                              {{tab.label}}
                         </p-tab>
                    </div>
                    }
               </p-tablist>
               <p-tabpanels>
                    <p-tabpanel [value]="0">
                         <div class="chart">
                              <p-chart type="bar" [data]="barChartData" [options]="toggleThemeOptions()" width="100%"
                                   height="350px" />
                         </div>
                    </p-tabpanel>
                    <p-tabpanel [value]="1">
                         <div class="chart">
                              <p-chart type="line" [data]="lineChartData" [options]="toggleThemeOptions()" width="100%"
                                   height="350px" />
                         </div>
                    </p-tabpanel>
                    
               </p-tabpanels>
          </p-tabs>
          <div class="ch-footer">Tap on a bar/point to see the flight time for that month.</div>
          <div class="card">
               <div class="column">
                    <div class="row">
                         <div>{{activeYear}} Total</div>
                         <div>{{periodTotal | number: '1.1-2'}} hrs</div>
                    </div>
                    <div class="row">
                         <div>Highest Month - {{highestMonthLabel}}</div>
                         <div>{{highestMonth | number: '1.1-2'}} hrs</div>
                    </div>
                    <div class="row">
                         <div>Average for {{activeYear}}</div>
                         <div>{{periodAverage | number: '1.1-2'}} hrs</div>
                    </div>

               </div>
          </div>
     </div>
</div>